import { CallState, LoadingState } from '@lcs/shared/api';
import { createReducer, on } from '@ngrx/store';
import { onReset } from 'src/app/authentication/reset-reducer';
import { clearMailboxConfirmed } from '../../mailbox-messages/state/mailbox-message-detail.actions';
import { MailboxDetailView } from '../models/mailbox-detail-view.model';
import { GetMailboxDetail_mailbox } from '../queries/generated/GetMailboxDetail';
import * as MailboxDetailActions from './mailbox-detail.actions';

export const mailboxDetailFeatureKey = 'mailboxDetail';

export interface State {
   mailbox: MailboxDetailView | null;
   callState: CallState;
}

export const initialState: State = {
   callState: LoadingState.Init,
   mailbox: null,
};

export const reducer = createReducer(
   initialState,
   onReset(initialState),
   on(MailboxDetailActions.mailboxDetailLoad, MailboxDetailActions.mailboxDetailCancel, (state) => {
      return {
         ...state,
         callState: LoadingState.Loading,
         mailbox: null,
      };
   }),
   on(MailboxDetailActions.loadMailboxDetailSuccess, (state, action) => {
      const mailbox: GetMailboxDetail_mailbox = action.data;
      return {
         ...state,
         accountId: null,
         accountName: null,
         callState: LoadingState.Loaded,
         extension: {
            name: null,
            number: null,
         },
         isOnSystemPage: false,
         mailbox: {
            ...mailbox,
            createUser: mailbox.createUser as string | null,
            updateUser: mailbox.updateUser as string | null,
         },
      };
   }),
   on(MailboxDetailActions.loadMailboxDetailFailure, (state, action) => {
      return {
         ...state,
         callState: action,
      };
   }),
   on(MailboxDetailActions.saveMailboxDetail, clearMailboxConfirmed, (state) => {
      return {
         ...state,
         callState: LoadingState.Loading,
      };
   }),
   on(MailboxDetailActions.saveMailboxDetailFailure, (state) => {
      return {
         ...state,
         callState: LoadingState.Loaded,
      };
   })
);
